import React from 'react';

import { CoreHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { Box, Spacer } from '@bcp-nextgen-dx-component-factory/design-system';
import { Stepper } from '@components';
import { rem } from '@helpers';
import { useLogger } from '@hooks';
import { ROUTES, Routes, useNavigation } from '@navigation';
import { useNavigationStep } from '@store';

import { WizardItem } from '../../wizardMenu.helper';
import { WizardMenuSubItem } from '../wizardMenuSubItem';
import { useWizardMenuItemHelper } from './wizardMenuItem.helper';

interface WizardMenuItemProps {
	item: WizardItem;
	selectedIndex: number;
	parentIndex: number;
	totalChildrenCount: number;
	totalParentWithChildrenCount: number;
}

export const WizardMenuItem: React.FC<WizardMenuItemProps> = ({
	item,
	selectedIndex,
	parentIndex,
	totalChildrenCount,
	totalParentWithChildrenCount,
}) => {
	const logger = useLogger();
	const { navigate } = useNavigation();
	const { hasChildren, isCurrentMenu, wasFinished } = useWizardMenuItemHelper({
		childrenLength: item.children?.length || 0,
		selectedIndex,
		parentIndex,
		totalChildrenCount,
		totalParentWithChildrenCount,
	});
	const { current: currentStep } = useNavigationStep();

	const handleClickNavigateTo = () => {
		(item.route && navigate(item.route)) || (!!item.children?.length && navigate(item.children[0].route as Routes));
	};

	logger('WizardMenuItem > render', item);
	let lastIndex = 0;
	if (item.children && item.children?.length > 1) {
		lastIndex = item.children?.lastIndexOf(item.children[item.children?.length - 1]);
	}

	return (
		<Box
			key={item.route || CoreHelper.guid()}
			styles={{
				display: 'flex',
				flexDirection: 'column',
				paddingBottom: hasChildren && isCurrentMenu ? 'unset' : rem(24),
			}}
			onPress={wasFinished && currentStep !== ROUTES.subscriptionConclusion ? handleClickNavigateTo : undefined}
		>
			<Box styles={{ alignItems: 'center' }}>
				<Stepper
					text={item.title}
					isCurrentMenu={isCurrentMenu}
					parentIndex={parentIndex}
					wasFinished={wasFinished}
					key={`wizard-menu-stepper-${parentIndex}`}
				/>
			</Box>

			{hasChildren && isCurrentMenu && (
				<>
					<Spacer vertical={38} />
					{item.children?.map((childrenItem, childIndex: number) => {
						return (
							<>
								{item.children && item.children.length > 1 && lastIndex === childIndex && (
									<Spacer vertical={rem(20)} />
								)}
								<WizardMenuSubItem
									item={childrenItem}
									childIndex={childIndex}
									parentIndex={parentIndex}
									selectedIndex={selectedIndex}
									totalChildrenCount={totalChildrenCount + (childIndex + 1)}
									key={`wizard-menu-subitem-${childIndex}`}
								/>
							</>
						);
					})}
					<Spacer vertical={38} />
				</>
			)}
		</Box>
	);
};
